/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ seconds: NonNullable<unknown> }} Timeline_Legacy_Zoom_Seconds_TitleInputs */



/**
* | output |
* | --- |
* | "Zoom {seconds} seconds" |
*
* @param {Timeline_Legacy_Zoom_Seconds_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timeline_legacy_zoom_seconds_title = /** @type {((inputs: Timeline_Legacy_Zoom_Seconds_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeline_Legacy_Zoom_Seconds_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Zoom ${i?.seconds} secondes`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Zoom ${i?.seconds} Sekunden`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Zoom ${i?.seconds} secondi`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Zoom ${i?.seconds} секунд`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Zoom ${i?.seconds} segundos`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`缩放 ${i?.seconds} 秒`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`ズーム ${i?.seconds} 秒`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`ज़ूम ${i?.seconds} सेकंड`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Zoom ${i?.seconds} segundos`)
	return /** @type {LocalizedString} */ (`Zoom ${i?.seconds} seconds`)
});